<rt-button
  #tableConfigDropdownTrigger="rtOverlayOrigin"
  (click)="toggleTableConfigDropdown()"
  variant="default small has-icon only-icon"
  rt-overlay-origin
>
  <rt-icon name="table-edit"></rt-icon>
</rt-button>

<ng-template #columnVisibilityCheckbox let-context>
  <rt-checkbox
    [style.pointerEvents]="'none'"
    [disabled]="!context.options.removable"
    [checked]="context.visible"
  ></rt-checkbox>
</ng-template>

<ng-template #autoFitCheckbox>
  <rt-checkbox [style.pointerEvents]="'none'" [checked]="tableAutoFit"></rt-checkbox>
</ng-template>

<ng-template #closeDropdownButton>
  <rt-icon [name]="'close'" (click)="toggleTableConfigDropdown()"></rt-icon>
</ng-template>

<ng-template
  #tableConfigDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [width]="260"
  [open]="dropdownOpened"
  [origin]="tableConfigDropdownTrigger"
  (backdropClick)="toggleTableConfigDropdown()"
>
  <rt-dropdown>
    <rt-experimental-dropdown-item
      [label]="'rtu.search.table.adjust_columns' | translate"
      [heading]="true"
      [divider]="true"
    >
    </rt-experimental-dropdown-item>
    <div
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      [style.maxHeight]="'300px'"
      class="has-dark-scroll-y drag-boundary"
    >
      <rt-experimental-dropdown-item
        *ngFor="let column of tableColumns; trackBy: trackByColumnId"
        (click)="toggleColumnVisibility(column); $event.preventDefault()"
        [slotPrimary]="columnVisibilityCheckbox"
        [slotPrimaryContext]="column"
        [label]="column.label!"
        [divider]="true"
        [disableHoverEffects]="hoverEffects === false"
        cdkDrag
        cdkDropListLockAxis="y"
        cdkDragBoundary=".drag-boundary"
      >
      </rt-experimental-dropdown-item>
    </div>

    <rt-experimental-dropdown-item
      *ngIf="!hideAutoFit"
      (click)="tableAutoFitChange.emit(!tableAutoFit); $event.preventDefault()"
      [slotPrimary]="autoFitCheckbox"
      [label]="
        (tableAutoFit ? 'rtu.search.table.auto_fit_enabled' : 'rtu.search.table.auto_fit_disabled')
          | translate
      "
      [theme]="'dark'"
    >
    </rt-experimental-dropdown-item>
  </rt-dropdown>
</ng-template>
